import React from 'react';
import { TableRow, TableCell, Chip } from '@mui/material';
import { colors, fonts, spacing, tableStyles } from '../../constants';
import { getStatusColor } from '../../utils/projectsUtils';

/**
 * ProjectTableRow Component
 * Individual project row in table
 */
const ProjectTableRow = ({ project, getStatusColor }) => {
  return (
    <TableRow 
      key={project.id} 
      hover 
      sx={{ 
        backgroundColor: colors.backgroundWhite,
        '&:hover': { 
          backgroundColor: '#0e172a15',
          borderLeft: '3px solid #0e172a',
        },
        '&:nth-of-type(even)': {
          backgroundColor: colors.backgroundLight,
        },
      }}
    >
      <TableCell sx={{ ...tableStyles.cell, color: '#1b2538', fontWeight: fonts.weightMedium }}>
        {project.code}
      </TableCell>
      <TableCell sx={{ ...tableStyles.cell, color: '#1b2538' }}>{project.name}</TableCell>
      <TableCell sx={{ ...tableStyles.cell, color: '#1b2538' }}>
        <Chip
          label={project.region}
          size="small"
          sx={{
            backgroundColor: colors.primaryTintHover,
            color: colors.primary,
            fontWeight: fonts.weightSemiBold,
            fontSize: fonts.fontSizeXs,
          }}
        />
      </TableCell>
      <TableCell sx={{ ...tableStyles.cell, color: '#1b2538', maxWidth: '200px' }}>
        {project.description || '-'}
      </TableCell>
      <TableCell sx={{ ...tableStyles.cell, color: '#1b2538' }}>
        <Chip
          label={project.status}
          size="small"
          sx={{
            backgroundColor: getStatusColor(project.status) + '20',
            color: getStatusColor(project.status),
            fontWeight: fonts.weightSemiBold,
            fontSize: fonts.fontSizeXs,
          }}
        />
      </TableCell>
      <TableCell sx={{ ...tableStyles.cell, color: '#1b2538' }}>
        {project.startDate || project.start_date}
      </TableCell>
      <TableCell sx={{ ...tableStyles.cell, color: '#64748b' }}>
        {project.endDate || project.end_date}
      </TableCell>
    </TableRow>
  );
};

export default ProjectTableRow;
